<footer class="footer">
  <div class="d-sm-flex justify-content-center justify-content-sm-between py-2">
    <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © RollGame.com 2022</span>
  </div>
</footer>